import React from 'react'
import * as request from 'superagent'
import { getToken } from '../Commons/Authentication'
import moment from 'moment'
import store from '../Commons/store'
import Spinner from 'react-spinkit'

export default class PlanComponent extends React.Component {
    constructor(props) {
        super(props)
        this.state = ({ fecha: '', text: '', planes: [], responsable: {}, saving: false })
        store.subscribe(() => {
            this.setState({
                responsable: store.getState()
            })
        })
    }
    handleObservaciones() {
        this.setState({ text: this.refs.plan.value, dirty: true });
    }
    handleSave() {
        this.setState({ saving: true })
        request
            .post("api/v1/plan/register")
            .set("Authorization", "Bearer " + getToken())
            .send({
                numeroDocumento: this.props.identification,
                text: this.state.text
            }).set("Accept", "application/json")
            .end((err, res) => {
                let planes = this.state.planes
                var d = moment(res.body.timestamp, 'x').format('[Fecha: ]DD-MM-YYYY HH:mm')
                planes = [{ text: res.body.text, fecha: d, responsable: this.state.responsable[0].nombrecompleto }, ...planes]
                this.setState({ planes }, () => {
                    setTimeout(() => { this.setState({ saving: false, text:'' }); }, 1000)
                })

            })
    }
    componentWillMount() {
        request
            .get('api/v1/plan/?numeroDocumento=' + this.props.identification)
            .set('Authorization', 'Bearer ' + getToken())
            .set('Accept', 'application/json')
            .end((err, res) => {
                if (err) {
                    console.log(err)
                }
                if (res) {
                    // console.log(res.body)
                    if (res.body.length > 0) {
                        let planes = res.body.map((plan, id) => {
                            var d = moment(plan.timestamp, 'x').format('[Fecha: ]DD-MM-YYYY HH:mm')
                            return { text: plan.text, fecha: d, responsable: `Responsable: ${plan.userCreated[0].nombres} ${plan.userCreated[0].apellidos}` }
                        })
                        // this.setState({ planes: planes, text: planes[0].text })
                        this.setState({ planes: planes })

                    }
                }
            })
    }
    render() {
        return (
            <div className="containerPlan">
                {this.state.saving ?
                    <div className="subboxPlan">
                        <span>Guardando </span>
                        <br />
                        <br />
                        <br />
                        <Spinner name="ball-pulse-sync" color="steelblue" />
                        <br />
                        <br />
                        <br />
                    </div>
                    :
                    <div className="subboxPlan"><textarea id="planEditar" ref="plan" onChange={this.handleObservaciones.bind(this)} value={this.state.text}></textarea><button className="special-conditions" onClick={this.handleSave.bind(this)}>Guardar</button></div>
                }


                {this.state.planes.length < 0 ? '' :
                    this.state.planes.map((plan, id) => {
                        return (<div className="subboxPlan" key={`${id}sb`}><div className="fechaPlan">{plan.fecha}</div> <div className="responsablePlan">{plan.responsable}</div> <div className="textPlan">{plan.text.split(/\n/g).map((p,i) => { return <p key={`${i}po`}>{p}</p> })}</div></div>)
                    })
                }

            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/components/EstaDoSaludDashboard/PlanComponent.js